// extracted by mini-css-extract-plugin
export default {"ink":"e5xHK2Ed","warning":"qzFWeScO","error":"adxgmPJg"};